export function getAssetsImages(name: string) {
  return new URL(`/src/common/images/${name}`, import.meta.url).href;
}
